export function getAllCountries(countryRepository) {
  return countryRepository.getAll();
}